import React from 'react';
import styles from './AdminFormRow.module.css';

const AdminFormRow = ({ children, style }) => (
  <div className={styles.row} style={style}>
    {children}
  </div>
);
export default AdminFormRow;
